module.exports = __webpack_public_path__ + "img/ic_nav_shop.27a79255.svg";